// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DaOi","colMin":"styles_colMin__1wdQI"};